// src/components/Gallery.js
import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

export default function Gallery() {
  const prefix = process.env.PUBLIC_URL;

  const albums = {
    'TISS-IATLIS 2025': [
      { src: `${prefix}/gallery/events/TISS-IATLIS 2025/photo1.jpg` },
      { src: `${prefix}/gallery/events/TISS-IATLIS 2025/photo2.jpg` },
      { src: `${prefix}/gallery/events/TISS-IATLIS 2025/photo3.jpg` },
      { src: `${prefix}/gallery/events/TISS-IATLIS 2025/photo4.jpg` },
      { src: `${prefix}/gallery/events/TISS-IATLIS 2025/photo5.jpg` },
      { src: `${prefix}/gallery/events/TISS-IATLIS 2025/photo6.jpg` },
      { src: `${prefix}/gallery/events/TISS-IATLIS 2025/photo7.jpg` },
      { src: `${prefix}/gallery/events/TISS-IATLIS 2025/photo8.jpg` },
    ],
    'IITH': [
      { src: `${prefix}/gallery/events/IITH/photo1.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo2.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo3.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo4.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo5.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo6.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo7.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo8.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo9.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo10.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo11.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo12.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo14.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo15.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo16.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo17.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo18.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo19.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo20.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo21.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo22.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo23.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo24.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo25.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo26.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo27.jpg` },
      { src: `${prefix}/gallery/events/IITH/photo28.jpg` },
    ],
    'DUK': [
      { src: `${prefix}/gallery/events/DUK/photo1.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo2.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo3.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo4.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo5.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo6.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo7.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo8.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo9.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo10.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo11.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo12.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo14.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo15.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo16.jpg` },
      { src: `${prefix}/gallery/events/DUK/photo17.jpg` },
    ],
    'KU': [
      { src: `${prefix}/gallery/events/KU/photo1.jpg` },
      { src: `${prefix}/gallery/events/KU/photo2.jpg` },
      { src: `${prefix}/gallery/events/KU/photo3.jpg` },
    ],
  };

  const [open, setOpen] = useState(false);
  const [currentAlbum, setCurrentAlbum] = useState([]);
  const [index, setIndex] = useState(0);

  const handleOpenAlbum = (photos) => {
    setCurrentAlbum(photos);
    setIndex(0);
    setOpen(true);
  };

  return (
    <section
      id="gallery"
      data-aos="fade-up"
      className="py-20 px-6 bg-white text-gray-800 scroll-mt-24"
    >
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl font-bold mb-10 text-center transition-colors duration-300 hover:text-green-700">
          Gallery
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {Object.entries(albums).map(([title, photos], idx) => (
            <div
              key={idx}
              onClick={() => handleOpenAlbum(photos)}
              className="p-6 border-2 border-green-600 text-center text-lg font-semibold rounded-lg cursor-pointer hover:bg-green-50 hover:shadow-lg transition duration-300"
            >
              {title}
            </div>
          ))}
        </div>

        {open && (
          <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={currentAlbum}
            index={index}
            on={{
              view: ({ index }) => setIndex(index),
            }}
          />
        )}
      </div>
    </section>
  );
}
